import { getData, postData } from "../../components/utilities/UtilityFunctions";

// The values of the team scorecard of a team pairing, calculated by the API from the player games and the team
// pairing's modifiers: { scorecardId, results: { [columnId]: value }, submitBody, pairings }.
export const getTeamResults = (teamPairingId) =>
  getData(`/pairings/${teamPairingId}/teamResults`, {
    queryStringParameters: { pairingType: "TeamPairing" }
  });

// The results of a team pairing, or {} when they cannot be calculated (no scorecard yet, for instance).
export const getTeamResultValues = async (teamPairingId) => {
  try {
    return (await getTeamResults(teamPairingId))?.results || {};
  } catch (err) {
    console.error(err);
    return {};
  }
};

// The body for submitScores for the values on the scorecard page (calculated, or changed by the organizer):
// { pairingType, isDone, metaData, teamPlayer1Id, teamPlayer2Id, gameData }
export const getTeamSubmitBody = async (teamPairingId, values) =>
  (
    await postData(`/pairings/${teamPairingId}/teamResults`, {
      body: { pairingType: "TeamPairing", values }
    })
  ).submitBody;
